var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verification"},[_c('el-button',{attrs:{"size":"small","type":"primary","nums":_vm.num,"disabled":_vm.disabled || (!_vm.enable)},on:{"click":_vm.send}},[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }